import styled from 'styled-components';

export const StyledFAQ = styled.ul`
	h2 {
		font-size: 2.6rem;
		margin-bottom: 2.6rem;
		margin-top: 2.6rem;
	}
	li {
		margin-bottom: 1rem;
		margin-left: 3.6rem;
		list-style-type: square;
	}
	.spacer {
		height: 3.6rem;
	}
`;
